import { Eye, EyeOff } from 'lucide-react'
import { useState } from 'react'

import { useGetItchConnection, useGetItchConnectionCreds } from '@/gen/publicApi'

import { UnexpectedDataStateError } from '@/containers/unexpectedDataStateError'

import { Card, CardContent } from '@/components/card'
import IconButton from '@/components/iconButton'

interface Props {
    clientCode: string
    connectionId: string
}

export default function ItchConnectionDetails({ clientCode, connectionId }: Props) {
    const connection = useGetItchConnection(clientCode, connectionId, { query: { suspense: true } })

    if (!connection.data) {
        return <UnexpectedDataStateError />
    }

    return (
        <div className="grid grid-cols-4 gap-4 mb-4">
            <Card>
                <CardContent className="pt-6">
                    <h3>Dialect</h3>
                    <h5>{connection.data.dialect}</h5>
                </CardContent>
            </Card>
            <Card>
                <CardContent className="pt-6">
                    <h3>Username</h3>
                    <h5>{connection.data.username}</h5>
                </CardContent>
            </Card>
            <PasswordCard clientCode={clientCode} connectionId={connectionId} />
        </div>
    )
}

const DefaultPassword = '************'

function PasswordCard({ clientCode, connectionId }: Props) {
    const [password, setPassword] = useState(DefaultPassword)

    const handleShowPassword = () => {
        setPassword('password')
    }
    const handleHidePassword = () => {
        setPassword(DefaultPassword)
    }

    const onClick = password === DefaultPassword ? handleShowPassword : handleHidePassword

    const Icon = password === DefaultPassword ? Eye : EyeOff
    const tooltipText = password === DefaultPassword ? 'Show password' : 'Hide password'
    const text =
        password === DefaultPassword ? password : <PasswordText clientCode={clientCode} connectionId={connectionId} />

    return (
        <Card>
            <CardContent className="pt-6">
                <h3>Password</h3>
                <div className="flex items-center">
                    <div className="flex-grow">
                        <h5>{text}</h5>
                    </div>
                    <div>
                        <IconButton icon={Icon} tooltip={tooltipText} onClick={onClick} />
                    </div>
                </div>
            </CardContent>
        </Card>
    )
}

function PasswordText({ clientCode, connectionId }: Props) {
    const { data: creds } = useGetItchConnectionCreds(clientCode, connectionId)

    return creds?.password
}
